import ServerInfo from "../viewModels/ServerInfo";
import {
  DEFAULT_PORTS,
  DEFAULT_PORTS_BRAND,
  PASSWORD_PATTERN,
} from "../../assets/consts/index.js";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import {
  faHumidity,
  faMonitorHeartRate,
} from "../../assets/consts/faCharCodes";
import { getServerUrl } from "../components_v2/DeviceAsyncStorage";
import axios from "axios";
import i18n from "../locales/translate";

export const englishToPersianNumber = (num, sep) => {
  if (
    num == undefined ||
    num == null ||
    (isNaN(num) && !typeof num === "string")
  ) {
    return "";
  }
  var numStr = num.toString();
  var persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  var englishNumbers = [
    /0/g,
    /1/g,
    /2/g,
    /3/g,
    /4/g,
    /5/g,
    /6/g,
    /7/g,
    /8/g,
    /9/g,
  ];
  if (sep) {
    numStr = numStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${sep}`);
  }
  for (var i = 0; i < 10; i++) {
    numStr = numStr.replace(englishNumbers[i], persianNumbers[i]);
  }

  return numStr;
};
export const persianToEnglishNumber = (num, sep) => {
  if (
    num == undefined ||
    num == null ||
    (isNaN(num) && !typeof num === "string")
  ) {
    return "";
  }
  var numStr = num.toString();
  var englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  var persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  if (sep) {
    numStr = numStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${sep}`);
  }
  for (var i = 0; i < 10; i++) {
    numStr = numStr.replace(persianNumbers[i], englishNumbers[i]);
  }

  return numStr;
};

export const randomId = () => {
  return Math.random().toString().substring(2);
};

export const getServerInfo = async (httpClient, address, buildingId = "") => {
  // console.log(`try get server info from address`, address);
  // console.log(`try get server info from buildingId`, buildingId);
  // var result = new ServerInfo();
  var result = {
    serverId: "",
    publicAddress: "",
    localAddress: null,
    accessToken: "",
    userFullName: "",
    userId: "",
    ports: DEFAULT_PORTS,
    cloudPublicAddress: "",
  };
  try {
    var response = await httpClient.get(`${address}`);
    if (response.data) {
      let {
        isMain,
        mainServerIp,
        publicAddress,
        localAddress,
        mainServerAddress,
        serverId,
        httpPort,
        ports,
        cloudPublicAddress,
      } = response.data;
      // if is main server
      if (isMain || !mainServerIp) {
        result = ServerInfo.parse({
          serverId,
          publicAddress: publicAddress?.length !== 0 ? publicAddress : null,
          localAddress,
          accessToken: "",
          userFullName: "",
          userId: "",
          ports,
          cloudPublicAddress,
        });
        return result;
      }
      // else if is slave
      else if (mainServerIp) {
        var _httpPort = httpPort || "3030";
        mainServerAddress = `http://${mainServerIp}:${_httpPort}/`;
        var mainInfo = await getServerInfo(httpClient, mainServerAddress);
        if (mainInfo.publicAddress != address && !mainInfo.localAddress) {
          mainInfo.localAddress = address;
        }
        result = ServerInfo.parse(mainInfo);
        return result;
      } else {
        return null;
      }
    }
  } catch (e) {
    console.log(`error on util.getServerInfo`, e);
    return null;
  }
};

export const getFirstAvailableConnection = async (
  httpClient,
  addresses = [],
  buildingId = ""
) => {
  for (var i in addresses) {
    var inf = await getServerInfo(httpClient, addresses[i], buildingId);
    //console.log(`inf`, inf , httpClient , addresses[i])
    if (inf) {
      return addresses[i];
    }
  }

  return "";
};

export const convertHttpToWsUri = (
  serverAddress,
  ports = DEFAULT_PORTS_BRAND
) => {
  let _ports = { ...ports };
  if (checkNullObjValues(_ports)) {
    _ports = DEFAULT_PORTS_BRAND;
  }
  // === remove property  null and undefined value ===
  _ports = removeNullValueObj(_ports);
  const activePorts = checkActivePorts(_ports);
  const schemaPortWebSocket = getKeyByValue(_ports, activePorts.websocket);
  let newUrl = getLocation(serverAddress)?.hostname;
  // === add protocol => ws | wss ===
  newUrl = `${schemaPortWebSocket}://` + newUrl;
  // ===  add port ===
  if ((activePorts.websocket !== 443) | (activePorts.websocket !== 80)) {
    newUrl = newUrl + `:${activePorts.websocket}`;
  }

  if (newUrl[newUrl.length - 1] != "/") newUrl += "/";

  newUrl += "taplife";

  return newUrl;
};
export const convertWsToHttpUri = (
  serverAddressWS,
  ports = DEFAULT_PORTS_BRAND
) => {
  let _ports = { ...ports };
  if (checkNullObjValues(_ports)) {
    _ports = DEFAULT_PORTS_BRAND;
  }
  _ports = removeNullValueObj(_ports);
  const activePorts = checkActivePorts(_ports);
  const schemaPortWebFetch = getKeyByValue(_ports, activePorts.http);

  let newUrl = getLocationWS(serverAddressWS)?.hostname;
  newUrl = `${schemaPortWebFetch}://` + newUrl;
  // ===  add port ===
  if ((activePorts.http !== 443) | (activePorts.http !== 80)) {
    newUrl = newUrl + `:${activePorts.http}`;
  }
  return newUrl;
};
export const removeNullValueObj = (obj) => {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
};
export const convertToTime = (ticksInSecs) => {
  var ticks = Math.floor(ticksInSecs);
  var hh = Math.floor(ticks / 3600);
  var mm = Math.floor((ticks % 3600) / 60);
  var ss = ticks % 60;
  var result = "";
  if (hh > 0) {
    result = `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
  } else {
    result = `${pad(mm)}:${pad(ss)}`;
  }
  return result;
};
export const renameObjectKey = (obj, oldKey, newkey, newValue) => {
  let _obj = obj;
  if (!newkey in _obj) {
    _obj[newkey] = newValue;
  } else {
    _obj[newkey] = newValue;
  }
  delete _obj[oldKey];
  return _obj;
};
function pad(number) {
  number = "0" + number;
  return number.substr(number.length - 2);
}
export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}
export function checkActivePorts(ports) {
  // https wss || http ws || https ws || http wss
  // === websocket port === default SECURE_PORTS
  // const wsPort = ports?.wss || ports?.ws || CONSTS.DEFAULT_PORTS.ws;
  // const httpPort = ports?.https || ports?.http || CONSTS.DEFAULT_PORTS.http;

  // let createWsKeyValue = {};
  // createWsKeyValue[getKeyByValue(ports, wsPort)] = wsPort;
  // createWsKeyValue[getKeyByValue(ports, httpPort)] = httpPort;
  if (!ports) {
    ports = DEFAULT_PORTS_BRAND;
  }

  const websocket =
    ports?.wss ||
    ports?.ws ||
    DEFAULT_PORTS_BRAND.wss ||
    DEFAULT_PORTS_BRAND.ws;
  const http =
    ports?.https ||
    ports?.http ||
    DEFAULT_PORTS_BRAND.https ||
    DEFAULT_PORTS_BRAND.http;

  return { websocket, http };
  // if (BRANDING.NAME_EN === "TapLife") {
  //   const NON_SECURE_PORTS
  //   return {websocket ,http};
  // }
  // return SECURE_PORTS;
}
export function getLocation(href) {
  var match = href.match(
    /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
  );
  return (
    match && {
      href: href,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7],
    }
  );
}
export function getLocationWS(href) {
  var matchWS = href.match(
    /^(wss?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
  );
  return (
    matchWS && {
      href: href,
      protocol: matchWS[1],
      host: matchWS[2],
      hostname: matchWS[3],
      port: matchWS[4],
      pathname: matchWS[5],
      search: matchWS[6],
      hash: matchWS[7],
    }
  );
}
export function checkNullObjValues(obj) {
  if (typeof obj === "object") {
    return Object.values(obj).every((x) => x === null || x === "");
  }
  return false;
}
export const getDeviceIcon = (device) => {
  var icon = "\ue028"; // sensor (as default)
  switch (device.deviceType) {
    case DeviceTypes.MOTION_SENSOR:
      //icon = "\ue028"; // running
      if (device.movementDetected) {
        icon = "\ue029"; // with alert
      } else {
        icon = "\ue028"; // without alert
      }
      break;
    case DeviceTypes.THERMO_METER:
      icon = "\uf2c9"; // thermometer-half
      break;
    case DeviceTypes.HUMIDITY_SENSOR:
      icon = faHumidity;
      break;
    case DeviceTypes.VOLTAGE_SENSOR:
      icon = faMonitorHeartRate;
      break;
    case DeviceTypes.LIGHT_METER:
      //icon = "\uf6bc"; // candle-half
      icon = "\uf8b8"; // flashlight
      break;
    case DeviceTypes.DOOR_SENSOR:
      if (device.isOpen) {
        icon = "\uf52b"; // door-open
      } else {
        icon = "\uf52a"; // door-closed
      }
      break;
    case DeviceTypes.LEAK_DETECTOR:
      if (device.detected) {
        icon = "\ue029"; // faSensorAlert
      } else {
        icon = "\ue028"; // faSenesor
      }
      break;
    case DeviceTypes.SMOKE_DETECTOR:
      if (device.detected) {
        icon = "\ue02a"; // faSensorFire
      } else {
        icon = "\ue028"; // faSensor
      }
      break;
    case DeviceTypes.SENSOR_BINARY:
      if (device.value) {
        icon = "\ue02b"; // faSensorOn
      } else {
        icon = "\ue028"; // faSensor
      }
      break;
    default:
      console.log("no icon detected for deviceType", device.deviceType);
      break;
  }
  return icon;
};
export const getCaptchaCode = async (oldCaptchaId) => {
  let serverUrl = await getServerUrl();
  try {
    if (!serverUrl.endsWith("/")) serverUrl = serverUrl + "/";
    const res = await axios({
      url: `${serverUrl}auth/getCaptcha?oldCaptchaId=${oldCaptchaId || ""}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    if (res) {
      return res.data; // {captchaId,captchBase64Data }
    }
  } catch (error) {
    console.log("error get captcha code", error);
  }
};
export function validationPassword(password) {
  if (password && typeof password === "string") {
    return (
      !!password.match(/\d/) && !!password.match(/\D/) && password.length >= 5
    );
  }
  return false;
}
export const getIsRTL = () => {
  return !!i18n.isRTL;
};
export const getDir = () => {
  const isRTL = getIsRTL();
  return isRTL ? "rtl" : "ltr";
};